import * as Yup from "yup";

import { TERMINATION_TIME_END_OF_DAY, TERMINATION_TIME_IMMEDIATE } from "constants/index";

const createMarkEmployeeAsInactiveSchema = (futureTerminationUnassignment, joiningDate) => {
  return Yup.object().shape({
    reason: Yup.string().required("Reason for marking Inactive is required"),
    endDate: Yup.date()
      .nullable()
      .when("reason", (inactiveReason, schema) => {
        if (futureTerminationUnassignment && !!inactiveReason[0]) {
          const requiredSchema = schema.required("End date is required");
          return joiningDate
            ? requiredSchema.min(joiningDate, "End date cannot be before the employee's joining date")
            : requiredSchema;
        }
        return schema.notRequired();
      }),
    terminationTime: Yup.string()
      .nullable()
      .oneOf([TERMINATION_TIME_IMMEDIATE, TERMINATION_TIME_END_OF_DAY, null, undefined])
      .notRequired(),
    comments: Yup.string()
      .nullable()
      .max(260, "Comments cannot exceed 260 characters")
      .when("reason", (inactiveReason, schema) => {
        return inactiveReason[0] == "Other"
          ? schema.required("Comments are required when reason is 'Other'")
          : schema.notRequired();
      }),
  });
};

export default createMarkEmployeeAsInactiveSchema;
